import { useTranslation } from "react-i18next";

export function useI18n() {
  const { i18n } = useTranslation();
  const locale = i18n.language || "en-US";
  // Check if i18n is initialized and dir method exists before calling it
  const dir =
    i18n.isInitialized && typeof i18n.dir === "function" ? i18n.dir(locale) : "ltr";
  return { dir, locale, i18n };
}

// TODO: should allow null values and edit components instead
export function useT(
  namespace?: string,
): (key: string, defaultValue?: string, options?: any) => string {
  const { i18n } = useI18n();

  // Fallback function that returns the key or defaultValue
  const fallbackT = (key: string, defaultValue?: string) => defaultValue || key;

  // Safety check: if i18n is not initialized, return fallback function
  if (!i18n.isInitialized) {
    return fallbackT;
  }

  // This is a hack to load the namespace if it hasn't been loaded yet
  if (namespace) {
    if (
      typeof i18n.hasLoadedNamespace === "function" &&
      !i18n.hasLoadedNamespace(namespace)
    ) {
      if (typeof i18n.loadNamespaces === "function") {
        i18n.loadNamespaces(namespace).catch(() => {
          // Failed to load translation namespace
        });
      }
    }
  }

  // Get the translation function, with fallback if it returns null
  const t = i18n.getFixedT(i18n.language, namespace);
  if (!t) {
    return fallbackT;
  }

  // Wrap the translation function to ensure it always returns a string (never null)
  return (key: string, defaultValue?: string, options?: any): string => {
    let result: any;
    if (defaultValue !== undefined) {
      result = t(key, defaultValue, options);
    } else if (options !== undefined) {
      result = t(key, options);
    } else {
      result = t(key);
    }
    // Convert result to string, handling null/undefined cases
    if (result == null) {
      return defaultValue ?? key;
    }
    return String(result);
  };
}
